import { render, staticRenderFns } from "./ContrastSchool.vue?vue&type=template&id=a42749c0&scoped=true"
import script from "./ContrastSchool.vue?vue&type=script&lang=js"
export * from "./ContrastSchool.vue?vue&type=script&lang=js"
import style0 from "./ContrastSchool.vue?vue&type=style&index=0&id=a42749c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42749c0",
  null
  
)

export default component.exports